import axios from "axios";
import { baseURL } from "../config/index";
import api from "./apiURL";

export async function HospitalOTP(credentials) {
  try {
    const response = await axios.post(
      `${baseURL}/api/v1/partner/login/otp`,
      credentials
    );

    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function deleteVisit(data) {
  try {
    const response = await api.put(
      `${baseURL}/api/v1/partner/visit/delete?id=${data.visitID}`,
    );
    // handle success
    return response.data;
  } catch (error) {
    console.log(error);
    // handle error
    return null;
  }
}

export async function HospitalLog(credentials) {
  try {
    const response = await axios.post(
      `${baseURL}/api/v1/partner/login`,
      credentials
    );

    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function SpecialistAdd(data) {
  try {
    const response = await api.post(
      `${baseURL}/api/v1/partner/specialist/add`,
      data
    );

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function getSpecialist(id) {
  try {
    const response = await api.get(
      `${baseURL}/api/v1/partner/specialist/getAll/?partnerID=${id}`
    );
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getSpecialistPartner() {
  try {
    const response = await api.get(
      `${baseURL}/api/v1/partner/specialist/getAll`
    );
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function editSpecialist(data) {
  try {
    const response = await api.put(
      `${baseURL}/api/v1/partner/specialist/update`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function dutyType(data) {
  try {
    const response = await api.put(
      `${baseURL}/api/v1/partner/dutytypes/regular/add`,
      data
    );

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function UpdateOneTimeServices(data) {
  try {
    const response = await api.put(
      `${baseURL}/api/v1/partner/dutytypes/onetime/add`,
      data
    );

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function getAssignNames() {
  try {
    const response = await api.get(`${baseURL}/api/v1/partner/assign/names`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function BookingAppointment(data) {
  try {
    const response = await api.post(
      `${baseURL}/api/v1/partner/scheduling`,
      data
    );

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function getAssignedStaffList() {
  try {
    const response = await api.get(`${baseURL}/api/v1/partner/visits/get`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getAssignedStaffListAdminSide(id) {
  try {
    const response = await api.get(`${baseURL}/api/v1/partner/visits/get/?partnerID=${id}`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}
export async function verifyIFSC(ifscCode) {
  try {
    const response = await axios.get(`https://ifsc.razorpay.com/${ifscCode}`);
    return { error: false, data: response.data };
  } catch (error) {
    console.error("Invalid IFSC Code", error);
    return { error: true, data: null };
  }
}

export async function UpdateBankInfo(data) {
  try {
    const response = await api.put(`${baseURL}/api/v1/partner/bank/add`, data);

    return response.data;
  } catch (error) {
    console.log(error);

    return null;
  }
}

export async function EditHospitalDetails(hospitalID, data) {
  try {
    const response = await api.put(
      `${baseURL}/api/v1/admin/partner/edit?id=${hospitalID}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching hospital details:", error);
    throw error; // Re-throw to allow calling function to handle if needed
  }
}

export const DeleteHospital = async (id) => {
  try {
    const res = await api.delete(`/api/v1/admin/partner/delete?id=${id}`);
    return res.data;
  } catch (error) {
    return {
      error: true,
      message: error.response?.data?.message || "Request failed",
    };
  }
};

export const DeleteSpecialist = async (id) => {
  try {
    const res = await api.delete(`/api/v1/partner/specialist/delete?id=${id}`);
    return res.data;
  } catch (error) {
    return {
      error: true,
      message: error.response?.data?.message || "Request failed",
    };
  }
};

export const CancelVisit = async (visitId) => {
  try {
    console.log(visitId);
    const res = await api.put(`/api/v1/partner/visit/delete?id=${visitId}`);
    return res.data;
  } catch (error) {
    return {
      error: true,
      message: error.response?.data?.message || "Request failed",
    };
  }
};

export async function getRefferelBY(id) {
  try {
    const response = await api.get(`/api/v1/admin/user/referred/?id=${id}`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getPartnerInAdmin(id) {
  try {
    const response = await api.get(`/api/v1/partner/get/?partnerID=${id}`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getPartner() {
  try {
    const response = await api.get(`/api/v1/partner/get/`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function getPartnerView(id) {
  console.log("Fetching partner with ID:", id);
  try {
    const response = await api.get(`/api/v1/admin/partner/?id=${id}`);
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export const uploadMany = async (dataArray, partnerId, additionalData) => {
  console.log(partnerId);
  try {
    const formData = new FormData();

    let validFilesCount = 0;
    dataArray.forEach((data) => {
      if (data.imageUri instanceof File) {
        formData.append(data.type, data.imageUri);
        validFilesCount++;
      } else {
        console.error("Invalid file:", data.imageUri);
      }
    });

    if (validFilesCount === 0) {
      throw new Error("No valid files to upload");
    }

    for (let [key, value] of formData.entries()) {
      console.log(
        `  ${key}: ${value.name} (${(value.size / 1024).toFixed(2)} KB)`
      );
    }

    const uploadResponse = await api.put(
      "/api/v1/partner/verification/documents/upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("Upload Response:", uploadResponse.data);

    // Check if first API call was successful
    if (uploadResponse.data.error === false) {
      console.log("Document upload", additionalData, partnerId);

      // Second API Call - Update partner details with GST/PAN
      try {
        const editResponse = await api.put(
          `${baseURL}/api/v1/partner/update`,
          additionalData
        );

        console.log("Partner Edit Response:", editResponse.data);

        // Return combined success response
        return {
          success: true,
          data: {
            uploadData: uploadResponse.data,
            editData: editResponse.data,
          },
          message:
            "Documents uploaded and partner details updated successfully",
        };
      } catch (editError) {
        console.error(
          "Partner edit API error:",
          editError.response || editError
        );

        // Upload succeeded but edit failed
        return {
          success: false,
          partialSuccess: true,
          uploadData: uploadResponse.data,
          error: editError.response?.data?.message || editError.message,
          message: "Documents uploaded but failed to update partner details",
        };
      }
    } else {
      // First API returned error: true
      return {
        success: false,
        error: uploadResponse.data.message || "Document upload failed",
        data: uploadResponse.data,
      };
    }
  } catch (error) {
    console.error("Upload API error:", error.response || error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
    };
  }
};

export async function partnerVerification(data) {
  try {
    const response = await api.put(
      `/api/v1/admin/partner/documents/verify`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function partnerPortalEdit(data) {
  try {
    const response = await api.put(`/api/v1/partner/update`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function getStandByStaffs(role, date, subRole) {
  console.log("Fetching standby staffs for role:", role, "on date:", date, subRole);
  try {
    const response = await api.get(
      `/api/v1/partner/hcp/names/?role=${role}&subRole=${subRole}&startDate=${date}`
    );
    return response.data;
  } catch (error) {
    // Handle the error
    console.log(error);
  }
}

export async function assignStaffs(data) {
  try {
    const response = await api.put(`/api/v1/partner/visit/assign`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function actingHCPChange(data) {
  try {
    const response = await api.put(`/api/v1/partner/change/hcp`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function timeSlotChange(data) {
  try {
    const response = await api.put(`/api/v1/partner/visit/reschedule/time`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function getOLARouting(origin, destination) {
  try {
    const response = await api.get(`/api/v1/admin/ola/directions/?origin=${origin}&destination=${destination}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Ola routing:", error);
    return { error: true, message: "Failed to fetch route" };
  }
}

export async function partnerAssessmentFee(data) {
  try {
    const response = await api.put(`/api/v1/partner/pricing/add`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function servicePricing(data) {
  try {
    const response = await api.put(`/api/v1/partner/add/pricing`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}


// Helper function to convert base64 to File
function base64ToFile(base64String, filename = 'coverImage.jpg') {
  try {
    // Split the base64 string to get the mime type and data
    const arr = base64String.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  } catch (error) {
    console.error("Error converting base64 to file:", error);
    throw new Error("Failed to convert base64 string to file");
  }
}

// Main upload function
export async function partnerBanner(fileOrBase64) {
  console.log("Input:", fileOrBase64);

  try {
    const formData = new FormData();
    let file;

    // Check if it's already a File object
    if (fileOrBase64 instanceof File) {
      file = fileOrBase64;
      console.log("Input is a File object");
    }
    // Check if it's a Blob
    else if (fileOrBase64 instanceof Blob) {
      file = new File([fileOrBase64], 'coverImage.jpg', { type: fileOrBase64.type });
      console.log("Input is a Blob object");
    }
    // Check if it's a base64 string
    else if (typeof fileOrBase64 === 'string' && fileOrBase64.startsWith('data:')) {
      console.log("Input is a base64 string, converting to File...");
      file = base64ToFile(fileOrBase64, 'coverImage.jpg');
      console.log("Conversion successful");
    }
    else {
      throw new Error("Invalid file format. Expected File, Blob, or base64 string");
    }

    // Append file to FormData
    formData.append('coverImage', file);

    // Log the formData contents
    console.log("FormData contents:");
    for (let [key, value] of formData.entries()) {
      console.log(
        `  ${key}: ${value.name} (${(value.size / 1024).toFixed(2)} KB) - Type: ${value.type}`
      );
    }
    console.log("Form Data:", formData);
    // Make the API call
    const uploadResponse = await api.put(
      "/api/v1/partner/banner/add",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("Upload Response:", uploadResponse.data);

    // Check if upload was successful
    if (uploadResponse.data.error === false) {
      return {
        success: true,
        data: uploadResponse.data,
        message: "Cover image uploaded successfully",
      };
    } else {
      return {
        success: false,
        error: uploadResponse.data.message || "Cover image upload failed",
        data: uploadResponse.data,
      };
    }
  } catch (error) {
    console.error("Upload API error:", error.response || error);
    return {
      success: false,
      error: error.response?.data?.message || error.message,
    };
  }
}


export async function getPartnerAnalysis() {
  try {
    const response = await api.get(`/api/v1/admin/partner/dashboard/stats`);
    return response.data;
  } catch (error) {
    console.error(error);
    return "Something went wrong";
  }
}


export async function getPartnerDetails(id) {

  console.log(id)
  try {
    const response = await api.get(`/api/v1/admin/partner/dashboard/details?partnerID=${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return "Something went wrong";
  }
}


export async function addBranch(data) {
  try {
    const response = await api.post(`/api/v1/partner/branch/add`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}


export async function updateBranch(data) {
  try {
    const response = await api.put(`/api/v1/partner/branch/update`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function deleteBranch(partnerID, branchID) {
  console.log("d", partnerID, branchID)
  try {
    const response = await api.delete(`/api/v1/partner/branch/delete?partnerID=${partnerID}&branchID=${branchID}`);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}


export async function getPartnerPatients() {
  try {
    const response = await api.get(`/api/v1/partner/patients/get`);
    return response.data;
  } catch (error) {
    console.error(error);
    return "Something went wrong";
  }
}

export async function addPatient(data) {
  try {
    const response = await api.post(`/api/v1/partner/patient/add`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function updatePatient(data) {
  try {
    const response = await api.put(`/api/v1/partner/patient/update`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function checkPhoneExists(phone) {
  try {
    const response = await api.post(`/api/v1/user/checkPhone`, { phone: Number(phone) });
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}

export async function uploadDischargeSummary(data) {
  try {
    if (!data?.patientID) {
      return { error: true, message: "MRN is missing" };
    }

    const formData = new FormData();
    formData.append("patientID", String(data.patientID));
    formData.append("title", data?.title || "");
    if (data?.file) {
      formData.append("dischargeSummary", data.file);
    }

    const response = await api.put(`/api/v1/partner/patient/discharge-summary/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    const status = Number(error?.response?.status || 0);
    const apiMessage = error?.response?.data?.message;
    if (status === 413) {
      return {
        error: true,
        status,
        message:
          "File size exceeds the server upload limit. Please compress the PDF and try again.",
      };
    }
    return {
      error: true,
      status,
      message: apiMessage || "Failed to upload discharge summary.",
    };
  }
}

export async function createVisitForPatient(data) {
  try {
    const response = await api.put(`/api/v1/partner/visit/create`, data);
    return response.data;
  } catch (error) {
    console.log(error);
    return "Something went wrong";
  }
}


export async function getPatientById(id) {
  try {
    const response = await api.get(`/api/v1/partner/patient/get/id?patientID=${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return "Something went wrong";
  }
}

export async function getPatientDischargeSummaries(patientID) {
  try {
    const response = await api.get(`/api/v1/partner/patient/discharge-summary/get?patientID=${patientID}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return "Something went wrong";
  }
}
